import { render, staticRenderFns } from "./up-bt.vue?vue&type=template&id=019a938b"
import script from "./up-bt.vue?vue&type=script&lang=js"
export * from "./up-bt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports